export default __webpack_public_path__ + "static/media/blog.1cd6f514.jpg";